import React from "react";
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import $ from "jquery";
// import draftToHtml from 'draftjs-to-html';
// import htmlToDraft from 'html-to-draftjs';
import fire from "../../config/firebase";
import { withRouter } from "react-router-dom";

class Notes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editorState: EditorState.createEmpty(),
    };
  }

  componentDidMount = async () => {
    const { key } = this.props.match.params;
    const dataType = this.props.match.path.includes("estimates")
      ? "estimates"
      : "templates";
    const notesRef = fire.database().ref(dataType + "/" + key + "/notes");

    const snapshot = await notesRef.once("value");
    const notes = snapshot.val();
    notesRef.off("value");
    if (notes) {
      this.setState({
        editorState: EditorState.createWithContent(
          convertFromRaw(JSON.parse(notes.content))
        ),
      });
    } else {
      this.setState({
        editorState: EditorState.createEmpty(),
      });
    }

    $(".summary-details .increment").on("click", function () {
      const no = parseInt($(this).parent().find("input").val());
      $(this)
        .parent()
        .find("input")
        .val(no + 1);
      console.log("this is " + no);
    });
    $(".summary-details .delete").on("click", function () {
      const no = parseInt($(this).parent().find("input").val());
      $(this)
        .parent()
        .find("input")
        .val(no - 1);
    });
  };

  onEditorStateChange = (editorState) => {
    const contentState = editorState.getCurrentContent();
    this.saveContent(contentState);
    this.setState({
      editorState,
    });
  };

  saveContent = (content) => {
    const arr = this.props.location.pathname.split('/');
    const key = arr[arr.length - 1];
    const dataType = this.props.match.path.includes("estimates")
      ? "estimates"
      : "templates";
    const notesRef = fire.database().ref(dataType + "/" + key + "/notes");
    const notes = {
      content: JSON.stringify(convertToRaw(content)),
    };
    notesRef.update(notes);
    window.localStorage.setItem("content", notes.content);
  };

  render() {
    const { editorState } = this.state;
    return (
      <div id="notes" className="table col s12 l12">
        <form>
          <div className="input-field">
            <Editor
              editorState={editorState}
              toolbarClassName="toolbarClassName"
              wrapperClassName="wrapperClassName"
              editorClassName="editorClassName"
              onEditorStateChange={this.onEditorStateChange}
              placeholder="Types your notes here..."
              toolbar={{
                options: ["inline", "link", "list"],
                inline: {
                  options: ["bold", "italic", "underline"],
                },
                link: {
                  options: ["link"],
                },
                list: {
                  options: ["unordered", "ordered"],
                },
              }}
            />
          </div>
        </form>
      </div>
    );
  }
}

export default withRouter(Notes);
